import { Route, Switch, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { URL_ID } from "constants/constants.js";

// public pages
import Shop from "../shop/Shop";
import Tours from "../tours/Tours";
import Home from "../home/Home";
import ReserveTour from "../reserve_tour/ReserveTour";
import TakTour from "../taktour/index.jsx";
import TourList from "../admin-panel/tour-list/TourList";

import Attractions from "../Attractions/Attractions";

// admin panel
import Management from "../admin-panel/management/Management";
import FinancialDepartment from "../admin-panel/financial-department/index";
import AdminLayout from "../admin-panel/Layout";
import AdminReservation from "../admin-panel/reservation/index";
import UserManagement from "../admin-panel/user_management/UserManagement";
import UserReport from "../admin-panel/user_report/UserReport";
import TabsPage from "../admin-panel/create-tours/tabsPage/TabsPage";

// customer panel
import CustomerPanelLayout from "../customer-panel/Layout";
import CustomerProfile from "../customer-panel/customer-profile/CustomerProfile";
import CustomerPanel from "../customer-panel/customer-panel/CustomerPanel";
import Transactions from "../customer-panel/Transaction/Transactions";
import Orders from "../customer-panel/Order/Orders";

// only in development
import AllPages from "../all-pages/AllPages";
import Test from "all-pages/test";

export default function Routes() {
  const auth = useContext(AuthenticationContext);

  console.log("auth in routes", auth);
  return (
    <>
      <Switch>
        <Route path="/" exact component={Home}></Route>
        <Route path="/shop" exact component={Shop}></Route>
        <Route path="/tours" exact component={Tours}></Route>
        <Route path="/reserve-tour/:id" exact component={ReserveTour}></Route>

        <Route path="/tak-tour/:tourId" exact component={TakTour}></Route>

        <Route
          path="/admin-panel/tour-list"
          render={() => {
            return auth.userInfo.accessLevel.includes(URL_ID.adminTourList.id) ? <TourList /> : <Redirect to="/" />;
          }}
          exact
        ></Route>

        <Route path="/attractions" exact component={Attractions}></Route>

        <Route path={["/customer-panel/dashboard", "/customer-panel/profile", "/customer-panel/transactions", "/customer-panel/orders"]}>
          <CustomerPanelLayout>
            <Route
              path="/customer-panel/profile"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.customerProfile.id) ? <CustomerProfile /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/customer-panel/dashboard"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.customerDashboard.id) ? <CustomerPanel /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/customer-panel/transactions"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.customerTransactions.id) ? <Transactions /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/customer-panel/orders"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.customerOrders.id) ? <Orders /> : <Redirect to="/" />;
              }}
            ></Route>
          </CustomerPanelLayout>
        </Route>

        <Route
          path="/admin-panel/create-tour/:tour_id?"
          exact
          render={() => {
            console.log("auth.userInfo.accessLevel.includes(URL_ID.adminCreateTour.id", auth.userInfo.accessLevel.includes(URL_ID.adminCreateTour.id), auth.userInfo.accessLevel);
            return auth.userInfo.accessLevel.includes(URL_ID.adminCreateTour.id) ? <TabsPage /> : <Redirect to="/" />;
          }}
        ></Route>

        <Route path={["/admin-panel/user-management", "/admin-panel/user-report/:edit_key", "/admin-panel/management", "/admin-panel/reservation", "/admin-panel/financial-department"]}>
          <AdminLayout>
            <Route
              path="/admin-panel/user-management"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.adminUserManagement.id) ? <UserManagement /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/admin-panel/user-report/:edit_key"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.adminUserReport.id) ? <UserReport /> : <Redirect to="/" />;
              }}
            ></Route>

            <Route
              path="/admin-panel/management"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.adminManagement.id) ? <Management /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/admin-panel/financial-department"
              exact
              render={() => {
                return auth.userInfo.accessLevel.includes(URL_ID.adminFinancial.id) ? <FinancialDepartment /> : <Redirect to="/" />;
              }}
            ></Route>
            <Route
              path="/admin-panel/reservation"
              exact
              render={() => {
                // return auth.userInfo.accessLevel.includes(URL_ID.adminReservation.id) ? <AdminReservation /> : <Redirect to="/" />;
                return <AdminReservation />;
              }}
            ></Route>
          </AdminLayout>
        </Route>
        <Route path="/all-pages" exact component={AllPages}></Route>
        <Route path="/testing" exact component={Test}></Route>
      </Switch>
    </>
  );
}
